import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from "../../components/Footer";
import TreatmentsTemplate from '../../components/Treatments-template'
import imgBg from '../media/Endodoncia.png'
import endoImg from '../media/endo.jpg'
import {useTranslation, Trans} from 'react-i18next'


export default function Endo() {
    const { t } = useTranslation();

    return (
        <>
            <Navbar></Navbar>
            <TreatmentsTemplate 
            backgroundImage = {imgBg}
            title = {t('endoPageTitle2')}
            paragraph = {t('endoPageTitle2Paraf')}
            textTitle = {t('endoPageTitle')}
            mediaContent = 
            {
            `# ${t('endoPageTitle')}
***  

**${t('endoPageSubtitle')}**  
  
${t('endoPageParaf')}

![](${endoImg})
            `
            }
             >
            
            </TreatmentsTemplate>
            <Footer></Footer>
        </>
    )
}
